type PhoneMobileDefaultType = {
  phone_code: string;
  phone_code_id: string;
};

export const phoneMobileDefault: PhoneMobileDefaultType = {
  phone_code: process.env.REACT_APP_defaults_phone_code ?? "+27",
  phone_code_id: process.env.REACT_APP_defaults_phone_code_id ?? "197",
};
